/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TGetPikJkModel,
  IGetPikJkRequest,
  IMappers,
  IGetPikJkResponse,
  IGetPikJkResponseError,
  TGetPikJkResponse,
} from './types';

const defaultConfig: TGetPikJkModel = {
  apiType: 'legacy',
  assertStatusCodes: [200, 400],
  method: 'GET',
  microserviceName: 'monolith-python',
  pathApi: '/cian-api/site/v1/get-pik-jk/',
  hostType: 'api',
} as TGetPikJkModel;

function createGetPikJkModel(parameters: IGetPikJkRequest): TGetPikJkModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IGetPikJkOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: IGetPikJkRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchGetPikJk<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: IGetPikJkOptions<TResponse200, TResponse400>): Promise<TResponse200 | TResponse400 | TGetPikJkResponse> {
  const { response, statusCode } = await httpApi.fetch(createGetPikJkModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetPikJkResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as IGetPikJkResponseError);
    }
  }

  return { response, statusCode } as TGetPikJkResponse;
}

export { defaultConfig, createGetPikJkModel, fetchGetPikJk };
